if (!customElements.get('ump-multicut-premium')) {
  customElements.define('ump-multicut-premium', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-mc-data]').textContent);
      this.q = selector => this.querySelector(selector);
      this.qa = selector => [...this.querySelectorAll(selector)];
      const snapshot = this.config.snapshot;
      this.s = snapshot.strings;
      this.currency = this.config.preview ? 'USD' : this.config.currency || 'USD';
      this.money = value => Number.isFinite(value) ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:this.currency}).format(value / 100) : this.s.no_prices;
      const finance=this.config.finance || {};
      this.finance={enabled:finance.enabled===true && this.currency==='USD',months:Number(finance.months),annualRate:Number(finance.annualRate),downPercent:Number(finance.downPercent)};
      const f=this.finance;
      f.enabled=f.enabled && [24,36,48,60].includes(f.months) && Number.isFinite(f.annualRate) && f.annualRate>=0 && f.annualRate<=30 && Number.isFinite(f.downPercent) && f.downPercent>=0 && f.downPercent<=50;
      this.financeAssumptions=this.s.finance_assumptions.replace('{months}',String(f.months)).replace('{rate}',String(f.annualRate)).replace('{down}',String(f.downPercent));
      this.monthlyPayment=amount=>{
        if (!Number.isFinite(amount)) return null;
        const principal=amount*(1-f.downPercent/100),r=f.annualRate/1200;
        return r===0 ? principal/f.months : principal*r/(-Math.expm1(-f.months*Math.log1p(r)));
      };
      this.monthlyMoney=amount=>Number.isFinite(amount) ? '≈ '+new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.currency,maximumFractionDigits:0,minimumFractionDigits:0}).format(amount/100) : this.s.no_prices;
      this.classList.toggle('mc-has-finance',f.enabled);
      this.qa('[data-finance]').forEach(el=>el.hidden=!f.enabled);
      this.qa('[data-payment-assumptions]').forEach(el=>el.textContent=this.financeAssumptions);
      const live = this.config.live;
      this.models = snapshot.models.map(model => {
        const variant = live?.variants?.find(v => String(v.id) === String(model.id));
        return {...model, price:this.config.preview ? model.price : variant?.price ?? null};
      });
      this.accessories = snapshot.accessories.map(item => {
        if (item.kind === 'handheld') {
          const model = this.models[item.modelIndex];
          return {...item, variants:[model], price:model.price};
        }
        const product = this.config.accessoryProducts[item.key];
        const variants = this.config.preview ? item.variants : product?.variants || item.variants;
        const price = this.config.preview ? item.price : product?.variants?.[0]?.price ?? null;
        return {...item, variants, price};
      });
      const params = new URL(location.href).searchParams;
      const variantId = params.get('variant');
      const index = this.models.slice(0,2).findIndex(v => String(v.id) === variantId);
      this.modelIndex = Math.max(0,index);
      const quantity = Number(params.get('mc_qty'));
      this.quantity = Number.isInteger(quantity) && quantity >= 1 && quantity <= 20 ? quantity : 1;
      this.selected = new Set((params.get('mc_options') || '').split(',').filter(key => this.accessories.some(item => item.key === key)));
      this.q('[data-quantity]').value=String(this.quantity);
      this.qa('[data-addon]').forEach(input => {input.checked=this.selected.has(input.dataset.addon);});
      this.qa('[data-model]').forEach(input => {input.checked = Number(input.value) === this.modelIndex;});
      this.addEventListener('change', event => {
        const target = event.target;
        if (target.matches('[data-model]')) this.setModel(Number(target.value));
        if (target.matches('[data-addon]')) {
          target.checked ? this.selected.add(target.dataset.addon) : this.selected.delete(target.dataset.addon);
          this.update();
        }
        if (target.matches('[data-quantity]')) this.normalizeQuantity();
      });
      this.q('[data-quantity]').addEventListener('input', event => {
        const n = Number(event.target.value);
        if (Number.isInteger(n) && n >= 1 && n <= 20) {this.quantity=n;this.update();}
      });
      this.q('[data-quantity]').addEventListener('blur', () => this.normalizeQuantity());
      this.addEventListener('click', event => {
        const choice = event.target.closest('[data-choose-model]');
        if (choice) this.setModel(Number(choice.dataset.chooseModel));
        const heroChoice = event.target.closest('[data-hero-model]');
        if (heroChoice) this.setModel(Number(heroChoice.dataset.heroModel));
        const remove = event.target.closest('[data-remove-option]');
        if (remove) {
          const key=remove.dataset.removeOption;
          this.selected.delete(key);this.q('[data-addon="'+key+'"]').checked=false;
          this.update();this.q('[data-addon="'+key+'"]').focus({preventScroll:true});
        }
        const addOption = event.target.closest('[data-add-option]');
        if (addOption) {
          const key = addOption.dataset.addOption;
          const input = this.q('[data-addon="'+key+'"]');
          if (input) {input.checked=true;this.selected.add(key);this.update();}
        }
        const quote = event.target.closest('[data-quote]');
        if (quote && !this.validQuantity()) event.preventDefault();
      });
      this.qa('[data-currency]').forEach(el => el.textContent=this.currency);
      this.update();
    }
    normalizeQuantity() {
      const input=this.q('[data-quantity]');
      const n=Number(input.value);
      this.quantity=Number.isFinite(n)?Math.max(1,Math.min(20,Math.floor(n))):1;
      input.value=String(this.quantity);
      this.q('[data-error]').hidden=true;
      this.update();
    }
    validQuantity() {
      const input=this.q('[data-quantity]');
      if (input.value!=='' && input.checkValidity()) return true;
      const error=this.q('[data-error]');error.textContent=this.s.qty_error;error.hidden=false;
      input.reportValidity();input.focus();return false;
    }
    setModel(index) {
      if (![0,1].includes(index)) return;
      this.modelIndex=index;
      this.qa('[data-model]').forEach(input=>input.checked=Number(input.value)===index);
      const url=new URL(location.href);url.searchParams.set('variant',this.models[index].id);history.replaceState({},'',url);
      this.update();
    }
    quoteUrl(title, lines) {
      const root=this.config.root || '/';
      const url=new URL(root.replace(/\/$/,'')+'/pages/request-equipment-quote',this.config.storeUrl || location.origin);
      url.searchParams.set('model',title);
      url.searchParams.set('family', title.startsWith('UMP Weld') ? 'handheld-laser-welding' : 'sheet-metal-fiber-laser');
      url.searchParams.set('product_title','UmproTech MultiCut & Weld');
      url.searchParams.set('configuration',lines.join('\n'));
      url.searchParams.set('comparison',lines.join('\n'));
      url.searchParams.set('source','multicut-configurator');
      url.searchParams.set('source_path',location.pathname);
      return url.toString();
    }
    update() {
      const model=this.models[this.modelIndex];
      this.q('[data-summary-title]').textContent=model.title;
      this.q('.mc-summary-image').src=model.image;
      this.q('.mc-summary-image').alt=model.title;
      this.qa('[data-model-price]').forEach(el=>el.textContent=this.money(this.models[Number(el.dataset.modelPrice)].price));
      this.q('[data-start-price]').textContent=this.money(model.price);
      this.q('[data-hero-name]').textContent=model.title;
      this.q('[data-hero-spec]').textContent=['24.4 × 24.4 in · 80W CO₂','54.3 × 36.2 in · 130W CO₂'][this.modelIndex];
      this.q('.mc-hero-machine').src=model.image;
      this.q('.mc-hero-machine').alt=model.title;
      this.qa('[data-hero-model]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.heroModel)===this.modelIndex)));
      this.accessories.forEach(item=>{
        this.q('[data-addon-price="'+item.key+'"]').textContent=this.money(item.price);
      });
      let complete=Number.isFinite(model.price);
      let subtotal=(model.price || 0)*this.quantity;
      const items=[{title:model.title,price:model.price,quantity:this.quantity,id:model.id}];
      this.accessories.forEach(item=>{
        if (!this.selected.has(item.key)) return;
        const matched=item.key==='rotary' ? item.variants.find(v=>v.title===model.title) : item.variants[0];
        if (item.key==='rotary' && !matched) {
          this.selected.delete(item.key);this.q('[data-addon="'+item.key+'"]').checked=false;return;
        }
        complete=complete && Number.isFinite(item.price);
        subtotal+=(item.price||0)*this.quantity;
        items.push({title:item.title+(item.key==='rotary'?' / '+model.title:''),price:item.price,quantity:this.quantity,id:matched?.id,key:item.key});
      });
      const list=this.q('[data-summary-list]');list.replaceChildren();
      const lines=items.map(item=>{
        const row=document.createElement('li');
        const name=document.createElement('span');name.textContent=item.title+' × '+item.quantity;
        const price=document.createElement('span');price.textContent=this.money(Number.isFinite(item.price)?item.price*item.quantity:null);
        row.append(name,price);
        if (item.key) {
          const remove=document.createElement('button');remove.type='button';remove.className='mc-remove';remove.dataset.removeOption=item.key;remove.textContent='×';remove.setAttribute('aria-label',this.s.remove_option+' '+item.title);row.append(remove);
        }
        list.append(row);
        return name.textContent+' — '+price.textContent;
      });
      const display=complete?this.money(subtotal):this.s.no_prices;
      this.q('[data-total]').textContent=display;
      this.q('[data-mobile-total]').textContent=display;
      this.qa('[data-monthly]').forEach(el=>{
        const target=el.dataset.monthly;
        const amount=target==='total' ? (complete ? subtotal : null) : target==='hero' ? model.price : this.models[Number(target)]?.price;
        el.textContent=this.monthlyMoney(this.monthlyPayment(amount));
      });
      lines.push(this.s.equipment_subtotal+': '+display+' '+this.currency,this.s.subtotal_note);
      if (this.finance.enabled && complete) lines.push(this.s.finance_example+': '+this.money(this.monthlyPayment(subtotal))+this.s.per_month+'. '+this.financeAssumptions+' '+this.s.monthly_caveat);
      const url=this.quoteUrl(model.title,lines);
      this.qa('[data-quote]').forEach(link=>link.href=url);
      this.qa('[data-add-option]').forEach(link=>{
        const key=link.dataset.addOption;
        link.querySelector('[data-option-label]').textContent=this.s[(this.selected.has(key)?'added_':'add_')+key];
      });
      this.qa('[data-handheld]').forEach(link=>{
        const item=this.models[Number(link.dataset.handheld)];
        link.href=this.quoteUrl(item.title,[item.title+' — '+this.money(item.price)+' '+this.currency,this.s.handheld_intro,this.s.subtotal_note]);
      });
      const stateUrl=new URL(location.href);
      this.selected.size ? stateUrl.searchParams.set('mc_options',[...this.selected].join(',')) : stateUrl.searchParams.delete('mc_options');
      this.quantity>1 ? stateUrl.searchParams.set('mc_qty',String(this.quantity)) : stateUrl.searchParams.delete('mc_qty');
      if (stateUrl.href!==location.href) history.replaceState({},'',stateUrl);
    }
  });
}
